/**
 * =====================================================
 * Mining Survey WebGIS
 * Global Application State
 * =====================================================
 */

class ApplicationState {
    constructor() {
        this.map = null;

        this.marker = null;

        this.accuracyCircle = null;

        this.watchId = null;

        this.followMode = false;

        this.currentPosition = null;

        this.measurementActive = false;

        this.track = {
            isRecording: false,

            isPaused: false,

            startTime: null,

            endTime: null,

            distance: 0,

            elapsed: 0,

            currentSpeed: 0,

            averageSpeed: 0,

            acceptedPoints: 0,

            ignoredPoints: 0,

            points: [],
        };
        this.waypoints = [];
        this.layers = {
            base: {
                osm: null,
            },

            system: {
                track: null,
                waypoints: null,
            },

            raster: {
                basemap: null,

                dem: null,
            },

            imported: [],
        };
    }
}

export default new ApplicationState();
